import React, { useRef, useState } from "react";

import {
  Pause as PauseIcon,
  Play as PlayIcon,
} from "@hl/base-components/lib/assets/icons.generated";
import { Video } from "@hl/base-components/lib/video";
import { Box, createStyles, Skeleton, UnstyledButton } from "@mantine/core";

import { ContentTypeInfo } from "~utils/contentType";

import { PageSupportedMediaType } from "../../../apollo/graphql.generated";

import MainImage from "./MainImage";

type MediaTypes = {
  animation: string;
  image?: string;
  contentTypeInfo: ContentTypeInfo | null;
  hasGate: boolean;
};

const useStyles = createStyles(() => ({
  video: {
    width: "100%",
    display: "block",
  },
  audioButton: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 10,
    width: 70,
    height: 70,
    backgroundColor: "white",
    borderRadius: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const CardAnimation = ({
  animation,
  contentTypeInfo,
  image,
  hasGate,
}: MediaTypes) => {
  const { classes } = useStyles();
  const audioRef = useRef<HTMLAudioElement>(null);
  const [audioPlaying, setAudioPlaying] = useState(false);

  const onAudioButtonClick = () => {
    if (audioRef.current) {
      if (audioPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
    }
    setAudioPlaying(!audioPlaying);
  };
  if (!contentTypeInfo) {
    return <Skeleton h={300} />;
  }

  if (contentTypeInfo.type === PageSupportedMediaType.VIDEO) {
    return (
      <Video className={classes.video} autoPlay loop muted playsInline>
        <source
          src={animation}
          type={`${contentTypeInfo.type.toLowerCase()}/${contentTypeInfo.mime?.toLowerCase()}`}
        />
      </Video>
    );
  }
  return (
    <Box style={{ position: "relative" }}>
      <MainImage src={image ?? ""} hasGate={hasGate} />
      <audio
        src={animation}
        controls
        style={{ visibility: "hidden", position: "absolute" }}
        ref={audioRef}
      />
      <UnstyledButton
        onClick={onAudioButtonClick}
        className={classes.audioButton}
      >
        {audioPlaying ? <PauseIcon /> : <PlayIcon />}
      </UnstyledButton>
    </Box>
  );
};

export default CardAnimation;
